import styled from "styled-components";

export const PageHeader = styled.div`
  text-align: center;
  margin-bottom: 40px;
  padding: 0 20px;
`;

export const PageTitle = styled.h1`
  font-size: 28px;
  font-weight: 700;
  color: #1F1F1F;
  margin: 0 0 8px 0;
  letter-spacing: -0.5px;
`;

export const PageSubtitle = styled.p`
  font-size: 15px;
  color: #5f6368;
  margin: 0;
  font-weight: 400;
`;

export const FormWithChecklistWrapper = styled.div`
  display: flex;
  gap: 40px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px 32px;
  align-items: flex-start;

  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: stretch;
  }

  @media (max-width: 768px) {
    padding: 0 20px 20px;
    gap: 32px;
  }

  @media (max-width: 600px) {
    padding: 0 16px 16px;
    gap: 24px;
  }
`;

export const FormContainer = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;
  overflow-y: auto;
  max-height: calc(100vh - 350px);
  padding-right: 8px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #E2E6EA;
    border-radius: 3px;

    &:hover {
      background: #bdc1c6;
    }
  }

  @media (max-width: 768px) {
    gap: 24px;
    max-height: none;
  }

  @media (max-width: 600px) {
    gap: 20px;
    padding-right: 0;
  }
`;

export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  background: #ffffff;
  padding: 24px;
  border-radius: 12px;
  border: 1px solid #E2E6EA;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;

  &:hover {
    border-color: #E2E6EA;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }

  @media (max-width: 600px) {
    padding: 16px;
    gap: 16px;
  }
`;

export const SectionTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #1F1F1F;
  margin: 0 0 4px 0;
  padding-bottom: 12px;
  border-bottom: 2px solid #1264C7;
  letter-spacing: -0.3px;
  display: flex;
  align-items: center;
  gap: 8px;

  .material-icons {
    font-size: 20px;
    color: #1264C7;
  }
`;

export const SectionDescription = styled.p`
  margin: -8px 0 0;
  color: #5f6368;
  font-size: 14px;
  line-height: 1.55;
`;

export const InlineHelp = styled.div`
  padding: 14px 16px;
  border-radius: 12px;
  border: 1px solid #D6E4F7;
  background: #f8fbff;
  color: #0B4FA8;
  font-size: 14px;
  line-height: 1.55;
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  /* MUI TextField customization */
  .MuiTextField-root {
    .MuiOutlinedInput-root {
      border-radius: 8px;
      background: #ffffff;
      transition: all 0.2s ease;

      &:hover {
        background: #F7F9FC;
      }

      &.Mui-focused {
        background: #ffffff;
        box-shadow: 0 0 0 3px rgba(66, 133, 244, 0.1);
      }

      .MuiOutlinedInput-notchedOutline {
        border-color: #E2E6EA;
        transition: border-color 0.2s ease;
      }

      &:hover .MuiOutlinedInput-notchedOutline {
        border-color: #bdc1c6;
      }

      &.Mui-focused .MuiOutlinedInput-notchedOutline {
        border-color: #1264C7;
        border-width: 2px;
      }
    }

    .MuiInputLabel-root {
      color: #5f6368;
      font-size: 14px;
      font-weight: 500;

      &.Mui-focused {
        color: #1264C7;
        font-weight: 600;
      }
    }

    .MuiInputBase-input {
      color: #1F1F1F;
      font-size: 14px;
      padding: 14px;

      &::placeholder {
        color: #9aa0a6;
        opacity: 1;
      }
    }
  }

  /* Para campos que ocupam a linha toda */
  & > :only-child {
    grid-column: 1 / -1;
  }
`;
